// "Did you mean ...?" under a French box, from the spelling check that rides
// on the translation call (Leanne, 23 Oct 2026: phrases saved misspelt were
// then scored against the wrong word). One component for the add and edit
// forms. `suggestion` is { for: the text it was checked against, text }, so a
// suggestion for something since retyped never shows.
export default function SpellingSuggestion({ suggestion, current, onAccept }) {
    if (!suggestion?.text || suggestion.for !== current) return null;
    return (
        <p className="text-xs text-stone-600" data-testid="spelling-suggestion">
            Did you mean: <span className="font-medium text-foreground">{suggestion.text}</span>{' '}
            <button type="button" onClick={() => onAccept(suggestion.text)}
                    className="font-semibold text-primary underline underline-offset-2 hover:text-primary/80"
                    data-testid="spelling-suggestion-accept">
                Use this
            </button>
        </p>
    );
}
